export const EVC_LISTINGS_LIMIT = 10;

export const SORTING_ORDERS = {
    ASC: "asc",
    DESC: "desc"
}

export const NOT_ALLOWED_TO_UPDATE_SITES = ["Technician"]
